import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ProvisioningStatus } from '@ui/aos-lib';
import { BaseStationProvisioningStatus } from '../base-stations-listing-page.types';

export const provisioningStatusLabelMap: Partial<Record<BaseStationProvisioningStatus, string>> = {
  [BaseStationProvisioningStatus.Inventoried]: TranslateRegistry.get.FILTER.PROVISIONING_STATUS.INVENTORIED,
  [BaseStationProvisioningStatus.Provisioned]: TranslateRegistry.get.FILTER.PROVISIONING_STATUS.PROVISIONED,
  [BaseStationProvisioningStatus.ProvisionedReady]: TranslateRegistry.get.FILTER.PROVISIONING_STATUS.PROVISIONED_READY,
  [BaseStationProvisioningStatus.RanConfig]: TranslateRegistry.get.FILTER.PROVISIONING_STATUS.RAN_CONFIG,
  [BaseStationProvisioningStatus.UheConnected]: TranslateRegistry.get.FILTER.PROVISIONING_STATUS.UHE_CONNECTED
};

export const provisioningStatusBubbleMap: Partial<Record<BaseStationProvisioningStatus, ProvisioningStatus>> = {
  [BaseStationProvisioningStatus.Inventoried]: ProvisioningStatus.Inventoried,
  [BaseStationProvisioningStatus.Provisioned]: ProvisioningStatus.Provisioned,
  [BaseStationProvisioningStatus.ProvisionedReady]: ProvisioningStatus.ProvisionedReady,
  [BaseStationProvisioningStatus.RanConfig]: ProvisioningStatus.RanConfig,
  [BaseStationProvisioningStatus.UheConnected]: ProvisioningStatus.UheConnected
};
